(() => {
  const leadInputs = Array.from(document.querySelectorAll('[data-br-lead-tags]'));
  const popup = document.querySelector('[data-br-lead-popup]');
  if (!popup && !leadInputs.length) return;

  function cleanTag(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 42);
  }
  function updateLeadTags(input, extraTags) {
    if (!input) return;
    const tags = input.value.split(',').map((tag) => tag.trim()).filter(Boolean);
    (extraTags || []).filter(Boolean).forEach((tag) => tags.push(tag));
    input.value = Array.from(new Set(tags)).join(',');
  }
  leadInputs.forEach((input) => {
    const leadForm = input.closest('form');
    if (leadForm) leadForm.addEventListener('submit', () => updateLeadTags(input));
  });
  if (!popup) return;

  const storage = {
    get(key, session) { try { return (session ? window.sessionStorage : window.localStorage).getItem(key); } catch (e) { return null; } },
    set(key, value, session) { try { (session ? window.sessionStorage : window.localStorage).setItem(key, value); } catch (e) {} }
  };
  const panel = popup.querySelector('.br-lead-popup__panel');
  const form = popup.closest('form');
  const email = popup.querySelector('input[type="email"]');
  const tagsInput = popup.querySelector('[data-br-lead-tags]');
  const closeButtons = popup.querySelectorAll('[data-br-popup-close]');
  const success = popup.dataset.success === 'true';
  const formForceOpen = popup.dataset.forceOpen === 'true';
  const previewForceOpen = new URLSearchParams(window.location.search).get('br_popup') === '1';
  const forceOpen = formForceOpen || previewForceOpen;
  const delay = Math.max(0, Number(popup.dataset.delayMs) || 10000);
  const scrollThreshold = Math.min(0.95, Math.max(0.1, Number(popup.dataset.scrollThreshold) || 0.4));
  const frequencyDays = Math.max(1, Number(popup.dataset.frequencyDays) || 14);
  const dismissedKey = 'br_lead_popup_dismissed_at_v2';
  const subscribedKey = 'br_lead_popup_subscribed_v2';
  const sessionKey = 'br_lead_popup_opened_v2';
  let isOpen = false, armed = false, previousFocus = null, timer = null;

  function focusableElements() { return Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter((el) => !el.hasAttribute('hidden')); }
  function openPopup(trigger) {
    if (isOpen) return;
    popup.dataset.trigger = trigger || 'forced';
    updateLeadTags(tagsInput, ['br-trigger-' + cleanTag(popup.dataset.trigger)]);
    previousFocus = document.activeElement; popup.hidden = false; popup.setAttribute('aria-hidden','false'); document.body.classList.add('br-lead-popup-open'); storage.set(sessionKey,'1',true);
    window.requestAnimationFrame(() => { popup.classList.add('is-open'); (email || panel).focus({preventScroll:true}); });
    isOpen = true; removeTriggers();
  }
  function closePopup() {
    if (!isOpen) return;
    popup.classList.remove('is-open'); popup.setAttribute('aria-hidden','true'); document.body.classList.remove('br-lead-popup-open'); storage.set(dismissedKey,String(Date.now()));
    window.setTimeout(() => { popup.hidden = true; },230); if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({preventScroll:true}); isOpen = false;
  }
  function onScroll() { if (!armed || isOpen) return; const h=Math.max(document.documentElement.scrollHeight,document.body.scrollHeight); const p=(window.scrollY+window.innerHeight)/Math.max(h,1); if (p>=scrollThreshold) openPopup('scroll'); }
  function onMouseLeave(event) { if (armed && event.clientY<=0 && window.matchMedia('(pointer: fine)').matches) openPopup('exit'); }
  function onKeyDown(event) {
    if (!isOpen) return; if (event.key==='Escape') { closePopup(); return; } if (event.key!=='Tab') return;
    const f=focusableElements(); if (!f.length) { event.preventDefault(); panel.focus(); return; } const first=f[0], last=f[f.length-1];
    if (event.shiftKey && document.activeElement===first) { event.preventDefault(); last.focus(); } else if (!event.shiftKey && document.activeElement===last) { event.preventDefault(); first.focus(); }
  }
  function removeTriggers() { if (timer) window.clearTimeout(timer); window.removeEventListener('scroll',onScroll); document.documentElement.removeEventListener('mouseleave',onMouseLeave); }
  if (success) storage.set(subscribedKey,'1');
  closeButtons.forEach((button)=>button.addEventListener('click',closePopup)); document.addEventListener('keydown',onKeyDown);
  if (form) form.addEventListener('submit',()=>updateLeadTags(tagsInput,['br-trigger-'+cleanTag(popup.dataset.trigger)]));
  if (forceOpen) { openPopup(success ? 'success' : formForceOpen ? 'error' : 'preview'); return; }
  const subscribed=storage.get(subscribedKey)==='1'; const opened=storage.get(sessionKey,true)==='1'; const dismissedAt=Number(storage.get(dismissedKey)||0); const dismissedRecently=dismissedAt>0 && Date.now()-dismissedAt<frequencyDays*86400000; const inEditor=window.Shopify&&window.Shopify.designMode;
  if (subscribed||opened||dismissedRecently||inEditor) return;
  window.setTimeout(()=>{armed=true;},2500); timer=window.setTimeout(()=>openPopup('delay'),delay); window.addEventListener('scroll',onScroll,{passive:true}); document.documentElement.addEventListener('mouseleave',onMouseLeave);
})();